export default __webpack_public_path__ + "3a4dbef63c081a4eb63ae15b2a805bec.png";